export default "__VITE_ASSET__Cf9SFFWo__"